import { Button, makeStyles } from "@material-ui/core";
import Store from "common/store";
import StoreKeys from "common/storeKeys";
import * as React from "react";
import EventFormatService from "services/EventFormatService";
import EventFormatBracketBuilder from "./EventFormatBracketBuilder";
import EventFormatDetails from "./EventFormatDetails";
import EventFormatHelper, {
	buildScoringDetails,
} from "common/helpers/eventFormatHelper";
import { SetLoading } from "common/components/Loader/Loader";
import { toast } from "react-toastify";
import { EventFormatBuilder } from "common/helpers/eventFormatHelper";
import { EventStageTypes } from "common/constants/EventStageTypes";

const useStyles = makeStyles((theme) => {
	return {
		buttonRow: {
			marginTop: theme.spacing() * 2,
			marginBottom: 12,
		},
	};
});

export default function EventFormatEditor() {
	const classNames = useStyles();

	const validateFormat = (eventFormat) => {
		if (!eventFormat.name) {
			toast.error("Event format needs a name.");
			return false;
		}

		return true;
	}

	const save = async () => {
		/** @type {EventFormatBuilder} */
		const formatBuilder = Store.get(
			StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT
		);

		// Update Scoring incase it wasn't updated previously
		buildScoringDetails(formatBuilder);

		const eventFormat = { ...formatBuilder.eventFormat };
		formatBuilder.data.stages = formatBuilder.data.stages.map(s => {
			switch (s.type) {
				case EventStageTypes.Swiss:
					return {
						...s,
						playoffDetails: null,
						groupStageDetails: null,
						bracket: null
					};
				case EventStageTypes.Group:
					return {
						...s,
						playoffDetails: null,
						swissStageDetails: null,
						bracket: s.groupStageDetails.hasGroupBrackets ? s.bracket : null
					};
				case EventStageTypes.Playoffs:
					return {
						...s,
						swissStageDetails: null,
						groupStageDetails: null
					};
				default:
					console.error('You got a stage type that doesn\'t exist.');
					return { ...s };
			}
		});
		eventFormat.json = JSON.stringify(formatBuilder.data);

		if (!validateFormat(eventFormat)) {
			return;
		}

		SetLoading(true, "Saving Format");
		try {
			const updatedFormat = await EventFormatService.saveFormat(eventFormat);
			const formatBuilder =
				EventFormatHelper.getEventFormatBuilder(updatedFormat);
			Store.set(StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT, formatBuilder);
			Store.set(StoreKeys.EVENTFORMATBUILDER.EVENT_FORMATS, null);
		} catch (error) {
			console.error(error);
		}
		SetLoading(false);
	};

	const saveAndClose = async () => {
		await save();
		Store.set(StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT, "");
	};

	const cancel = () => {
		Store.set(StoreKeys.EVENTFORMATBUILDER.CURRENT_FORMAT, "");
	};

	return (
		<>
			<EventFormatDetails />
			<EventFormatBracketBuilder />

			<div className={classNames.buttonRow}>
				<Button color="primary" onClick={save}>
					SAVE
				</Button>
				<Button color="primary" onClick={saveAndClose}>
					SAVE AND CLOSE
				</Button>
				<Button color="secondary" onClick={cancel}>
					CANCEL
				</Button>
			</div>
		</>
	);
}
